import React from 'react'
import { NavLink } from 'react-router-dom'

function Logo(props,className) {
	return (
		<>
			<NavLink to="/" className={`flex ${`text-` + props.textSize} font-bold flex-col items-start gap-0 2xl:gap-1 ${className}`} aria-label="ast-logo">
				<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 441 170" className={`w-10 md:w-[52px] h-auto ${className}`} fill={props.fill || 'black'}>
					<g>
						<path d="M9.37,147.78c0-0.08,0-0.16,0-0.24c0.26-0.28,0.56-0.53,0.79-0.84c10.13-13.61,20.26-27.21,30.38-40.83
		c20.09-27.06,40.2-54.1,60.24-81.21c2.54-3.44,5.62-6.06,9.37-8c7.38-3.83,15.07-5.44,23.27-3.27c6.79,1.8,12.29,5.72,16.84,10.92
		c4.34,4.95,8.55,10.03,12.62,15.21c18.57,23.61,35.95,48.1,53.25,72.64c0.62,0.88,1.26,1.21,2.33,1.21
		c29.66-0.03,59.32-0.04,88.98,0.02c1.74,0,2.77-0.67,3.64-1.96c1.94-2.87,2.49-6.07,2.28-9.47c-0.35-5.61-3.76-8.81-9.41-8.81
		c-30.06,0.01-60.12,0-90.18,0.04c-0.97,0-1.49-0.33-2-1.11c-12.09-18.56-24.2-37.12-36.34-55.65c-0.61-0.93-0.67-1.58-0.04-2.52
		c6.99-10.38,16.8-16.61,28.82-19.59c6.39-1.59,12.9-1.62,19.42-1.63c36.58-0.03,73.15-0.08,109.73-0.06
		c40.53,0.01,81.07,0.08,121.6,0.13c0.46,0,0.93,0,1.45,0c0,11.29,0,22.41,0,33.67c-16.1,0-32.14,0-48.29,0c0,0.7,0,1.25,0,1.8
		c0.03,21.32,0.07,42.64,0.09,63.97c0.01,12.86,0,25.72,0.01,38.57c0,0.52,0.04,1.03,0.06,1.55c-14.71,0-29.42,0-44.14,0
		c0.03-0.43,0.1-0.87,0.1-1.3c0.04-14.93,0.08-29.86,0.09-44.8c0.02-19.73,0-39.45,0-59.18c0-0.43,0-0.85,0-1.38
		c-0.56,0-0.95,0-1.34,0c-48.81,0-97.62,0-146.42,0.01c-1.27,0-2.56,0.08-3.82,0.27c-5.4,0.82-8.08,4.39-7.2,9.72
		c0.88,5.35,3.8,9.56,7.73,13.16c1.05,0.96,2.18,1.39,3.66,1.38c19.51-0.16,39.01-0.24,58.52-0.38c12.87-0.09,25.74-0.25,38.61-0.37
		c15.89-0.14,28.02,9.63,32.96,22.03c3.33,8.38,4.2,17.08,2.95,25.98c-1.25,8.87-5.25,16.28-12.41,21.75
		c-8.7,6.65-18.65,9.71-29.56,9.71c-40.65,0.01-81.31,0-121.96,0.02c-0.95,0-1.49-0.27-1.98-1.1c-8.24-13.98-16.5-27.94-24.78-41.9
		c-8.85-14.93-17.72-29.86-26.58-44.78c-1.57-2.65-5.76-4.48-8.8-3.87c-2.51,0.5-4.11,2.15-5.43,4.19
		c-5.82,8.97-11.67,17.93-17.48,26.92c-12.32,19.07-24.63,38.14-36.91,57.23c-0.54,0.83-1.08,1.2-2.1,1.16
		c-1.88-0.07-3.76,0.01-5.63,0.05c-13.91,0.29-27.81,0.6-41.72,0.89C12.89,147.8,11.13,147.78,9.37,147.78z"/>
						<path d="M78.82,149.89c0.27-0.5,0.45-0.88,0.67-1.25c13.27-22.05,26.57-44.07,39.77-66.16c1.2-2.02,4.43-2.77,6.28-1.05
		c0.66,0.62,1.28,1.33,1.76,2.1c6.53,10.5,12.96,21.07,19.56,31.52c6.77,10.73,13.71,21.36,20.57,32.03
		c0.23,0.36,0.45,0.74,0.8,1.31C138.36,148.89,108.67,149.39,78.82,149.89z"/>
					</g>
				</svg>
				{
					props.text && <span className={`text-[10px] font-medium leading-none ${className}`} style={{ lineHeight: '10px' }}>{props.text}</span>
				}

			</NavLink>
		</>
	)
}

export default Logo